// src/components/support/SupportTransparencyCta.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import {Button} from '@dopomogai/ui';
import { ArrowRight } from 'lucide-react';

interface SupportTransparencyCtaProps {
  onAction: (actionType: string, payload?: any) => void;
}

export const SupportTransparencyCta: React.FC<SupportTransparencyCtaProps> = ({ onAction }) => {
  const { t } = useTranslation('support_us');

  return (
    <section className="bg-emerald-600 text-white py-20 md:py-24">
      <div className="container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.25, 1, 0.5, 1] }}
        >
          <h2 className="text-3xl md:text-4xl font-bold leading-tight">
            {t('transparencyCta.headline')}
          </h2>
          <p className="mt-4 max-w-3xl mx-auto text-emerald-100 text-lg">
            {t('transparencyCta.text')}
          </p>

          {/* --- THE FIX: This div correctly centers the button --- */}
          <div className="mt-10 flex justify-center">
            <Button
              text={t('transparencyCta.button')}
              variant="secondary"
              size="lg"
              onClick={() => onAction('NAVIGATE_TO_PAGE', { path: '/impact' })}
              icon={<ArrowRight size={18} />}
              iconPosition="right"
              className="bg-white text-gray-900 hover:bg-slate-50 hover:shadow-[4px_4px_0_0_#022c22]"
            />
          </div>
          <p className="mt-8 text-xl font-semibold text-emerald-200 tracking-wider">
            {t('transparencyCta.gratitude')}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

